import {mixed, object, ObjectSchema, string} from "yup";
import {LightweightUser} from "./User";

export interface AuditInfo {
  createdBy?: LightweightUser,
  createdAt?: string,
  lastModifiedBy?: LightweightUser,
  lastModifiedAt?: string
}

export function auditInfoSchema(): ObjectSchema<AuditInfo> {
  return object({
    createdBy: mixed<LightweightUser>(),
    createdAt: string(),
    lastModifiedBy: mixed<LightweightUser>(),
    lastModifiedAt: string()
  })
}
